@if (iconName(); as iconName) {
  @if (socialMediaUrl()) {
    <a
      [olExternalLink]="socialMediaUrl()"
      [isMajiApp]="isMajiApp()"
      class="source-info outlaw-link"
      [class.left]="logoAlign() === 'left'"
      (click)="onSocialClick()"
      dataTest="post-social-link"
    >
      @if (logoSize(); as size) {
        <outlaw-icon [name]="iconName" [width]="size.width" [height]="size.height" />
      } @else {
        <outlaw-icon [name]="iconName" />
      }
    </a>
  } @else {
    <span class="source-info" dataTest="post-social-link">
      @if (logoSize(); as size) {
        <outlaw-icon [name]="iconName" [width]="size.width" [height]="size.height" />
      } @else {
        <outlaw-icon [name]="iconName" />
      }
    </span>
  }
}
